export class StorageRequest {
    storageGbAdjustment: number;
}
